import React, { useState } from "react";
import { StickyNavbar } from "../layout/StickyNavBar";
import { Link, useNavigate } from "react-router-dom";
import { isValidEmail, isValidPassword } from "../../utils/helpers";
import { AlertCustomStyles } from "../layout/AlertCustomStyles";
import AuthService from "../../services/auth.service";
import AuthTransferShowcase from "../layout/AuthTransferShowcase";
const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [verifyMode, setVerifyMode] = useState(false);
  /* const [sentCode, setSentCode] = useState("");
  const [loggedInUserId, setLoggedInUserId] = useState(""); */
  const [values, setValues] = useState({
    Email: "",
    Password: "",
  });
  let [errors, setErrors] = useState({
    Email: 0,
    Password: 0,
  });
  const inputs = [
    {
      id: 1,
      name: "Email",
      type: "email",
      placeholder: "Email",
      errorMessage: "Email address is invalid!",
      label: "Email",
      required: true,
    },
    {
      id: 4,
      name: "Password",
      type: "password",
      placeholder: "Password",
      errorMessage: "Password should be 8-20 characters!",
      label: "Password",
      pattern: `^[a-zA-Z0-9!@#$%^&*]{8,20}$`,
      required: true,
    },
  ];
  const [alert, setAlert] = useState("");
  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };
  const handleValidation = (e) => {
    if (e.target.name == "Email") {
      !isValidEmail(e.target.value)
        ? setErrors({ ...errors, [e.target.name]: 1 })
        : setErrors({ ...errors, [e.target.name]: 0 });
    }
    if (e.target.name == "Password")
      !isValidPassword(e.target.value)
        ? setErrors({ ...errors, [e.target.name]: 1 })
        : setErrors({ ...errors, [e.target.name]: 0 });
  };
  const loginCheck = () => {
    setLoading(true);
    AuthService.login(values.Email, values.Password).then(
      (res) => {
        /* setLoggedInUserId(res.loggedInUser.id); 
        if (!res.loggedInUser.status) {
          UserService.sendVerificationCode({
            email: res.loggedInUser.email,
            emailType: emailTypes.VERIFY,
          })
            .then((res) => {
              setLoading(false);
              setSentCode(res.code);
              setVerifyMode(true);
            })
            .catch((err) => {});
        } else {
          setLoading(false);
          navigate("/dashboard");
        } */
        setLoading(false);
        navigate("/dashboard");
      },
      (error) => {
        setLoading(false);
        setAlert("fail");
        setValues({ Email: "", Password: "" });
      }
    );
  };
  return (
    <div className="auth-page min-h-screen bg-[#f7f3ed] text-[#302521]">
      <div className="sticky top-0 z-50">
        <StickyNavbar pageType="login" />
      </div>
      <main className="flex min-h-[calc(100dvh-72px)] items-center justify-center px-4 py-2 sm:px-6 sm:py-6">
        {!verifyMode && (
          <div className="auth-frame grid w-full max-w-[760px] grid-cols-1 overflow-hidden rounded-[22px] border border-[#e6ddd2] bg-[#fffdf9] shadow-[0_24px_64px_rgba(66,48,34,0.12)] lg:min-h-[460px] lg:grid-cols-2">
            <section className="auth-form-panel flex flex-col justify-center px-6 py-4 sm:px-9 sm:py-8 lg:px-10">
            {alert && (
              <div className="login-form-alert">
                <AlertCustomStyles
                  status={alert}
                  message={"Signing in failed, Please try again"}
                />
              </div>
            )}
            <div className="mb-5">
              <h1 className="text-xl font-semibold leading-tight tracking-tight text-[#302521]">
                Welcome back
              </h1>
              <p className="mt-1.5 text-[13px] leading-relaxed text-[#766b64]">
                Log in to send money and track your transfers.
              </p>
            </div>
            <form className="w-full max-w-[290px]">
              <div className="mb-1 flex flex-col gap-3">
                {inputs.map((input) => (
                  <React.Fragment key={input.id}>
                    <div className="flex flex-col gap-1.5">
                    <label htmlFor={input.name} className="text-[10px] font-medium text-[#514641]">
                      {input.label}
                    </label>
                    <div className="relative h-[32px] w-full">
                      <input
                        id={input.name}
                        type={input.type}
                        placeholder={input.name === "Email" ? "you@example.com" : "Enter your password"}
                        onChange={onChange}
                        value={values[input.name]}
                        onBlur={handleValidation}
                        name={input.name}
                        disabled={loading}
                        autoComplete={input.name === "Email" ? "email" : "current-password"}
                        className="auth-input h-full w-full rounded-md border border-[#d8cfc4] bg-[#fffdf9] px-3 text-[12px] text-[#302521] outline-none transition placeholder:text-[#918482] focus:border-[#882699] focus:ring-2 focus:ring-[#882699]/15 disabled:opacity-60"
                      />
                    </div>
                    {errors[input.name] == 1 && (
                      <span className="ml-1 text-[10px] text-[#c53030]">
                        {input.errorMessage}
                      </span>
                    )}
                    </div>
                  </React.Fragment>
                ))}
              </div>
              <div className="mt-4 flex justify-end">
                <Link to={"/forgot-password"}>
                  <span className="text-[11px] font-medium text-[#882699] hover:underline">
                    Forgot password?
                  </span>
                </Link>
              </div>
              <button
                className="mt-4 w-full rounded-lg bg-[#882699] px-6 py-2 text-xs font-semibold uppercase tracking-wide text-white shadow-[0_6px_18px_rgba(136,38,153,0.18)] transition hover:bg-[#9e32b4] focus:outline-none focus:ring-2 focus:ring-[#882699]/30 focus:ring-offset-2 focus:ring-offset-[#fffdf9] disabled:pointer-events-none disabled:opacity-50"
                type="button"
                disabled={
                  !isValidEmail(values.Email) ||
                  !isValidPassword(values.Password)
                }
                onClick={loginCheck}
              >
                {loading && (
                  <>
                    <svg
                      aria-hidden="true"
                      role="status"
                      class="inline w-5 h-5 me-3 text-white animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor"
                      />
                    </svg>
                    Loading ...
                  </>
                )}
                {!loading && <>Log In</>}
              </button>
              <p className="mt-4 text-center text-[11px] text-[#766b64]">
                New to Adulis?
                <Link to={"/register"}>
                  <span className="ml-1 font-semibold text-[#882699] underline underline-offset-2">
                    Create an account
                  </span>
                </Link>
              </p>
            </form>
            <div className="mt-6 flex max-w-[430px] items-center justify-center gap-2 border-t border-[#e6ddd2] pt-3 text-[10px] text-[#766b64]">
              <svg className="h-3 w-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                <rect x="5" y="10" width="14" height="11" rx="2" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M8 10V7a4 4 0 1 1 8 0v3" />
              </svg>
              Your connection is secure
            </div>
            </section>
            <AuthTransferShowcase />
          </div>
        )}
        {/* {verifyMode && (
          <RegisterStepTwo
            onVerifyComplete={login}
            email={values.Email}
            originalSentCode={sentCode}
          />
        )} */}
      </main>
    </div>
  );
};
export default Login;
